import React, { useRef, useEffect, useState, useCallback } from "react";
import { Dropdown, Menu } from "antd";
import { Link } from "react-router-dom";
import PrescriptionForm from "../component/prescriptionForm"; // Importing the PrescriptionForm component
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import VitalSignsForm from "./vitalSigns";
import dayjs from "dayjs";
import InvoiceModal from "./modal/invoiceLayout";
import { useInvalidateAppointments, useUpdateAppointment } from "./api/app";
import {
    useCreatePrescription,
    useDeletePrescription,
    useUpdatePrescription,
} from "./api/prescription";
import ClinicalNotesModal from "./modal/clinicalNotesModal";
import PrintPres from "./modal/printPres";
import showToast from "../utils/toast";
import { deleteVacApp } from "../actions/vaccineAppointmentActions";
import AddAppVaccineModal from "./modal/addAppointment";
import { to12HourFormat } from "../utils/common";
import PrintBilling from "./modal/printBilling";
// import PrescriptionPDF from "./modal/prescriptionPDF";
// import { pdf } from "@react-pdf/renderer";

const AppointmentDetail = ({ lastElement, app, medicines = [] }) => {
    const [prescriptionForm, setPrescriptionForm] = useState(false);
    const [selectedPrescription, setSelectedPrescription] = useState(null); // For editing
    const [, setVitalSignsForm] = useState(false);
    const [, setSelectedVitalSign] = useState(null);
    const [, setMedicalHistory] = useState([]);
    const [prescription, setPrescriptions] = useState([]);
    const [showBilling, setShowBilling] = useState(false);
    const createPrescription = useCreatePrescription();
    const updatePrescription = useUpdatePrescription();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [notes, setNotes] = useState("");
    const appdetails = useSelector((state) => state.vaccineAppDetails);
    const [isEditing, setIsEditing] = useState(false);
    const [showClinicalModal, setShowClinicalModal] = useState(false);
    const [showPrintBilling, setShowPrintBilling] = useState(false);
    const [showPresPrintModal, setShowPresPrintModal] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const { appointment: { appointment } = [] } = appdetails;
    const deletePrescription = useDeletePrescription();

    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    const updateAppData = useUpdateAppointment();
    const invalidate = useInvalidateAppointments();

    useEffect(() => {
        if (!userInfo) {
            navigate("/signin");
        }
    }, [userInfo, navigate]);

    useEffect(() => {
        if (app) {
            setPrescriptions(app?.prescription ? app.prescription : []);
            // setClinicalNotes(
            //     app?.psychodiagnostic?.chiefComplaints
            //         ? [...app.psychodiagnostic.chiefComplaints]
            //         : []
            // );
        }
    }, [app]);

    // Handle form submission for creating or updating a prescription
    const handleFormSubmit = (newPrescriptions, existingPrescriptions) => {
        setPrescriptionForm(false);

        setSelectedPrescription(null);
        if (existingPrescriptions) {
            newPrescriptions.map((medicine) => {
                return updatePrescription.mutate({ pres: medicine });
            });
        } else {
            createPrescription.mutate({
                appId: app._id,
                prescriptions: newPrescriptions,
            });
        }
    };

    const handleVitalSignsSubmit = (vitalSigns) => {
        updateAppData.mutate({ _id: app._id, vitalSigns });
        setVitalSignsForm(false); // Hide the form after submission
        showToast("vital sign is changed");
    };

    // Handle editing a prescription
    const handleEditPrescription = () => {
        setSelectedPrescription([...prescription]);
        setPrescriptionForm(true); // Show form for editing
    };

    const handleCancel = () => {
        setPrescriptionForm(false); // Hide the form when canceled
        setSelectedPrescription(null);
    };

    const handleEditVitalSigns = () => {
        setSelectedVitalSign(app?.vitalSigns);
        setVitalSignsForm(true);
    };

    // Handle deleting a prescription
    const handleDeletePrescription = (prescriptionId) => {
        deletePrescription.mutate({ idx: app._id, presId: prescriptionId }); // Dispatch delete action
    };

    const handleAddNote = () => {
        updateAppData.mutate({ _id: app._id, notes });
        showToast("note is created");
    };

    const handleVitalCancel = () => {
        setVitalSignsForm(false);
        setSelectedVitalSign(null);
    };

    const closeAppointment = () => {
        updateAppData.mutate({ _id: app._id, status: "closed" });
        if (window.confirm("Are you sure")) {
            dispatch(deleteVacApp(app._id));
            showToast("appointment deleted");
        }
        invalidate();
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    useEffect(() => {
        setMedicalHistory(
            app?.patient?.medicalhistory
                ? [...app?.patient?.medicalhistory]
                : [],
        );
        setNotes(app?.notes);
    }, []);

    const fieldNames = [
        "Anxious Mood",
        "Tension",
        "Fears",
        "Insomnia",
        "Intellectual",
        "Depressed Mood",
        "Somatic (Muscular)",
        "Somatic (Sensory)",
        "Cardiovascular Symptoms",
        "Respiratory Systems",
        "Gastrointestinal Symptoms",
        "Gastrourinatory Symptoms",
        "Autonomic Symptoms",
        "Behaviour At Interview",
    ];

    const menu = (
        <Menu>
            <Menu.Item key="2">
                <Link
                    onClick={(e) => {
                        e.preventDefault();
                        setShowClinicalModal(true);
                    }}
                >
                    Clinical Notes
                </Link>
            </Menu.Item>

            <Menu.Item
                key="4"
                onClick={() => {
                    navigate(`/PsychologicalForm/${app?._id}`);
                    setVitalSignsForm(false);
                    setPrescriptionForm(false);
                }}
            >
                Psychodiagnostic Report
            </Menu.Item>
            <Menu.Item
                key="5"
                onClick={() => {
                    navigate(`/theoryRecordingForm/${app?._id}`);
                    setVitalSignsForm(false);
                    setPrescriptionForm(false);
                }}
            >
                Psyco therapy session
            </Menu.Item>
            <Menu.Item
                key="6"
                onClick={() => {
                    setShowBilling(true);
                }}
            >
                Billing
            </Menu.Item>
            <Menu.Item
                key="7"
                onClick={() => {
                    navigate(`/update-patient/${app?.patient?._id}`);
                }}
            >
                Edit Patient profile
            </Menu.Item>
            <Menu.SubMenu key="8" title="More">
                <Menu.Item key="8-1" onClick={() => setShowModal(true)}>
                    Edit Appointment
                </Menu.Item>
                <Menu.Item key="8-2" onClick={closeAppointment}>
                    Delete Appointment
                </Menu.Item>
            </Menu.SubMenu>
        </Menu>
    );

    // menu for view button
    const viewMenu = (
        <Menu>
            <Menu.Item key="1">
                <Link to={`/PsychologicalForm/${app?._id}`}>
                    Psychodiagnostic Report
                </Link>
            </Menu.Item>
            <Menu.Item key="2">
                <Link to={`/HamiltonForm/${app?._id}`}>
                    Hamilton Anxiety Rating Scale (HAM-A)
                </Link>
            </Menu.Item>
            <Menu.Item key="3">
                <Link to={`/hamd/${app?._id}`}>
                    Hamilton Depession Rating Scale (HAM-D)
                </Link>
            </Menu.Item>
            <Menu.Item key="4">
                <Link to={`/cdrs/${app?._id}`}>
                    Children's Depression Rating Scale (CDRS)
                </Link>
            </Menu.Item>
            <Menu.Item key="5">
                <Link to={`/YMRS/${app?._id}`}>
                    Young Mania Rating Scale(YMRS)
                </Link>
            </Menu.Item>
            <Menu.Item key="6">
                <Link to={`/ybocs/${app?._id}`}>
                    Yale-Brown Obsessive Compulsive Scale(YBOCS)
                </Link>
            </Menu.Item>
            <Menu.Item key="7">
                <Link to={`/panss/${app?._id}`}>
                    Positive and Negative Syndrome Scale(PANSS)
                </Link>
            </Menu.Item>
        </Menu>
    );
    const getQuantity = (dosageStr, durationStr) => {
        const dosage = dosageStr
            .split("-")
            .reduce(
                (sum, part) =>
                    sum +
                    (part.includes("½")
                        ? parseFloat(part.replace("½", ".5"))
                        : parseFloat(part)),
                0,
            );

        const match = durationStr.match(/(\d+)\s*(weeks|months|days)/);

        if (!match) return 0; // If no match, return 0

        const [_, num, unit] = match; // Destructure match array safely
        const duration =
            unit === "weeks"
                ? num * 7
                : unit === "months"
                  ? num * 30
                  : parseInt(num);

        return dosage * duration;
    };

    return (
        <>
            {showModal && (
                <AddAppVaccineModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    patientId={app?.patient?._id}
                    edit={true}
                    app={app}
                    doctorId={app?.doctor?._id}
                />
            )}
            <InvoiceModal
                show={showBilling}
                onClose={() => setShowBilling(false)}
                appId={app._id}
                app={app}
                expense={app?.billing}
            />
            {showClinicalModal && (
                <ClinicalNotesModal
                    handleClose={() => setShowClinicalModal(false)}
                    id={app?.clinicalNote?._id || null}
                    appointmentId={app._id}
                />
            )}
            {showPrintBilling && (
                <PrintBilling
                    show={showPrintBilling}
                    handleClose={() => setShowPrintBilling(false)}
                    appointment={app}
                    expense={app?.billing}
                />
            )}
            {/* app and Patient Info Section */}
            <div style={{ width: "100%" }} ref={lastElement}>
                <div
                    className="d-flex justify-content-between align-items-center"
                    style={{
                        background:
                            "linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)",
                        color: "white",
                        borderRadius: "25px",
                        padding: "12px 25px",
                        fontWeight: 500,
                        fontSize: "14px",
                        boxShadow: "rgba(102, 126, 234, 0.3) 0px 4px 15px",
                        transition: "0.3s",
                    }}
                >
                    <h6 style={{ margin: 0 }}>
                        <strong>
                            {dayjs(app?.date).format("DD MMMM , YYYY (dddd)")}
                        </strong>
                    </h6>

                    <Dropdown overlay={menu} placement="bottomRight" arrow>
                        <Button
                            type="default"
                            style={{
                                backgroundColor: "white",
                                color: "black",
                                borderRadius: "20px",
                                padding: "8px 16px",
                                fontWeight: "500",
                            }}
                        >
                            Add Record
                        </Button>
                    </Dropdown>
                </div>

                <div className="card-body">
                    <div>
                        <div
                            className=" border-danger p-2 rounded mb-1"
                            style={{
                                backgroundColor: "lightblue",
                                lineHeight: "1",
                            }}
                        >
                            <p className="mb-1">
                                {app.psychodiagnostic &&
                                    `pschodiagonostic form is updated on ${dayjs(
                                        app.psychodiagnostic.date,
                                    ).format("MMMM D, YYYY")}`}
                            </p>
                            <br />
                            <p className="mb-1">
                                {app.billing &&
                                    `Due amount is ${
                                        (
                                            app.billing.totalCost -
                                                app.billing.totalDiscount +
                                                app.billing.totalTax || 0
                                        ).toFixed(2) - app.billing.amountPaid
                                    }`}
                            </p>
                        </div>
                        <div
                            // ref={appointmentRef}
                            className="mb-4 p-3 border rounded"
                        >
                            <h6>
                                <strong>app Date:</strong>{" "}
                                {dayjs(app?.date?.toLocaleString()).format(
                                    "MMMM D, YYYY",
                                )}
                            </h6>
                            <h6>
                                <strong>app Time:</strong>{" "}
                                {to12HourFormat(app?.time)}
                            </h6>
                            <h6>
                                <strong>Doctor:</strong> Dr. {app?.doctor?.name}
                            </h6>
                            <h6>
                                <strong>Patient:</strong>{" "}
                                {app?.patient?.firstName}-
                                {app.patient.patientNumber}
                            </h6>

                            {/* Vital Signs Section */}
                            <div className="mb-4">
                                <div>
                                    <strong>Vital Signs</strong>
                                </div>
                                <div>
                                    <VitalSignsForm
                                        onSubmit={handleVitalSignsSubmit}
                                        existingVitals={app?.vitalSigns}
                                        handleCancel={handleVitalCancel}
                                        appId={app?._id}
                                        status={app?.status}
                                    />
                                </div>
                            </div>
                            {app.clinicalNote && (
                                <>
                                    <div className="mt-3">
                                        <strong>Clinical Notes</strong>
                                        <button
                                            style={{
                                                padding: "5px",
                                                marginLeft: "10px",
                                                border: "none",
                                            }}
                                            onClick={() =>
                                                setShowClinicalModal(true)
                                            }
                                        >
                                            <i className="fa fa-plus" />
                                        </button>
                                    </div>
                                    <div style={{ display: "block" }}>
                                        {app?.clinicalNote?.complaints && (
                                            <p>
                                                Complaints -{" "}
                                                {app.clinicalNote.complaints}
                                            </p>
                                        )}
                                        {app?.clinicalNote?.presentIllness && (
                                            <p>
                                                Present Illness -{" "}
                                                {
                                                    app.clinicalNote
                                                        .presentIllness
                                                }
                                            </p>
                                        )}
                                        {app?.clinicalNote?.investigations && (
                                            <p>
                                                Duration -{" "}
                                                {
                                                    app.clinicalNote
                                                        .investigations
                                                }
                                            </p>
                                        )}
                                        {app?.clinicalNote
                                            ?.psychiatricHistory && (
                                            <p>
                                                Past Psychiatric History -{" "}
                                                {
                                                    app.clinicalNote
                                                        .psychiatricHistory
                                                }
                                            </p>
                                        )}
                                        {app?.clinicalNote?.medicalHistory && (
                                            <p>
                                                Medical History -{" "}
                                                {
                                                    app.clinicalNote
                                                        .medicalHistory
                                                }
                                            </p>
                                        )}
                                        {app?.clinicalNote
                                            ?.treatmentHistory && (
                                            <p>
                                                Treatment History -{" "}
                                                {
                                                    app.clinicalNote
                                                        .treatmentHistory
                                                }
                                            </p>
                                        )}
                                        {app?.clinicalNote?.familyHistory && (
                                            <p>
                                                Family History -{" "}
                                                {app.clinicalNote.familyHistory}
                                            </p>
                                        )}

                                        {app?.clinicalNote?.diagnosis && (
                                            <p>
                                                Prov. Diagnosis -{" "}
                                                {app.clinicalNote.diagnosis}
                                            </p>
                                        )}
                                        {app?.clinicalNote?.Observations && (
                                            <p>
                                                Observations -{" "}
                                                {app.clinicalNote.Observations}
                                            </p>
                                        )}
                                        {app?.clinicalNote?.notes && (
                                            <p>
                                                Notes - {app.clinicalNote.notes}
                                            </p>
                                        )}
                                    </div>
                                </>
                            )}
                            {/* Prescriptions Section */}
                            <h6 className="mt-3">
                                <strong>
                                    Medicines:{" "}
                                    <button
                                        style={{
                                            padding: "5px",
                                            border: "none",
                                        }}
                                        onClick={() =>
                                            setPrescriptionForm(true)
                                        }
                                    >
                                        <i className="fa fa-plus" />
                                    </button>
                                </strong>
                                &nbsp;
                                {prescription && prescription.length !== 0 && (
                                    <span
                                        onClick={() => handleEditPrescription()}
                                        style={{ cursor: "pointer" }}
                                        className="me-2"
                                    >
                                        <i
                                            className="fa fa-pen"
                                            style={{
                                                color: "blue",
                                                fontSize: "18px",
                                                marginLeft: "5px",
                                            }}
                                        ></i>
                                    </span>
                                )}
                            </h6>

                            <table className="table table-bordered">
                                <tbody>
                                    {prescription &&
                                        prescription.map((pres, idx) => (
                                            <tr key={idx}>
                                                <td>{pres?.drug}</td>
                                                <td>{pres?.dosage}</td>
                                                <td>
                                                    {pres?.durationNumber +
                                                        " " +
                                                        pres?.durationUnit}
                                                </td>
                                                <td>{pres?.instruction}</td>
                                                <td>
                                                    {pres?.quantity ||
                                                        getQuantity(
                                                            pres?.dosage,

                                                            pres?.durationNumber +
                                                                pres?.durationUnit,
                                                        )}
                                                </td>
                                                {app?.status !== "closed" && (
                                                    <td>
                                                        <span
                                                            onClick={() =>
                                                                handleDeletePrescription(
                                                                    pres._id,
                                                                )
                                                            } // Delete prescription
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <i
                                                                className="fas fa-trash"
                                                                style={{
                                                                    color: "red",
                                                                    fontSize:
                                                                        "24px",
                                                                }}
                                                            ></i>
                                                        </span>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>

                        {prescriptionForm && (
                            <PrescriptionForm
                                onSubmit={handleFormSubmit}
                                existingPrescriptions={selectedPrescription} // Pass the selected prescription for editing
                                onCancel={handleCancel}
                                appId={app?._id}
                                patient={app?.patient._id}
                                doctor={app?.doctor._id}
                                medicines={medicines}
                            />
                        )}
                        {/* <PrintLayout html={prescription}></PrintLayout> */}
                        <div className="mt-4">
                            <div>
                                <strong>
                                    Billing Details:{" "}
                                    <button
                                        style={{
                                            padding: "5px",
                                            border: "none",
                                            margin: "2px",
                                        }}
                                        onClick={() => setShowBilling(true)}
                                    >
                                        <i className="fa fa-plus" />
                                    </button>
                                    {app?.billing && (
                                        <button
                                            style={{
                                                padding: "5px",
                                                border: "none",
                                                color: "#fff",
                                                background: "grey",
                                                margin: "2px",
                                            }}
                                            onClick={() => {
                                                setShowPrintBilling(true);
                                            }}
                                        >
                                            <i class="fa fa-print"></i>
                                        </button>
                                    )}
                                </strong>
                            </div>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Treatment Name</th>
                                        <th>Cost</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {app.billing &&
                                        app.billing.treatment &&
                                        app.billing.treatment.length !== 0 &&
                                        app.billing.treatment.map(
                                            (treatment, index) => (
                                                <>
                                                    <tr key={treatment.id}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            {treatment.name}
                                                        </td>
                                                        <td>
                                                            ₹{treatment.cost}
                                                        </td>
                                                    </tr>
                                                </>
                                            ),
                                        )}
                                    {app.billing && (
                                        <tr>
                                            <p style={{ padding: "5px" }}>
                                                Due Amount :{" "}
                                                {Math.abs(
                                                    app.billing.totalCost -
                                                        app.billing
                                                            .totalDiscount +
                                                        app.billing.totalTax ||
                                                        0,
                                                ).toFixed(2) -
                                                    app.billing.amountPaid}{" "}
                                            </p>
                                            <p style={{ padding: "5px" }}>
                                                Total Cost :{" "}
                                                {app.billing.grandTotal}{" "}
                                            </p>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <h5>Additional Notes</h5>
                            <div>
                                {isEditing ? (
                                    <>
                                        <textarea
                                            value={notes}
                                            onChange={(e) =>
                                                setNotes(e.target.value)
                                            }
                                            placeholder="Write your notes here..."
                                            maxLength={200}
                                            style={{
                                                width: "100%",
                                                height: "100px",
                                            }}
                                        />
                                        <br />
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "left",
                                                alignItems: "center",
                                                gap: "10px",
                                            }}
                                        >
                                            <button
                                                onClick={() => handleAddNote()}
                                                style={{
                                                    padding: "5px",
                                                    cursor: "pointer",
                                                    marginTop: "10px",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                Save
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setIsEditing(false);
                                                    setNotes(app?.notes);
                                                }}
                                                style={{
                                                    padding: "5px",
                                                    cursor: "pointer",
                                                    marginTop: "10px",
                                                    borderRadius: "5px",
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            gap: "10px",
                                            flexDirection: "row",
                                            width: "60%", // or use "fit-content" for dynamic size
                                            padding: "5px 0",
                                        }}
                                    >
                                        <p
                                            style={{
                                                margin: 0,
                                                flex: 1,
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {notes}
                                        </p>

                                        <button
                                            onClick={() => setIsEditing(true)}
                                            style={{
                                                padding: "5px",
                                                cursor: "pointer",
                                                border: "none",
                                                backgroundColor: "transparent",
                                                alignSelf: "flex-start",
                                            }}
                                            title="Edit Note"
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <PrintPres
                            show={showPresPrintModal}
                            handleClose={() => setShowPresPrintModal(false)}
                            appointment={app}
                        />
                        <div className="print-button d-flex justify-content-end mt-3">
                            {/* <Button variant="primary" onClick={() =>  navigate(`/print-prescription/${app?._id}`)}> */}
                            <Button
                                variant="primary"
                                onClick={() => {
                                    setShowPresPrintModal(true);
                                }}
                            >
                                view
                            </Button>
                        </div>
                        {/* <button onClick={()=>{
            const handleOpenPdfInNewTab = async () => {
  const blob = await pdf(<PrescriptionPDF appointment={app} />).toBlob();
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank');
};

          }} className="btn btn-primary">
  View PDF
</button> */}
                        {/* Print Button */}
                    </div>
                </div>
            </div>
        </>
    );
};

const styles = {
    dropdown: {
        marginTop: "20px",
        backgroundColor: "#007bff",
        display: "inline",
        color: "white",
        border: "none",
        padding: "10px 20px", // Padding to mimic button
        borderRadius: "5px", // Rounded corners like a button
        cursor: "pointer",
        fontSize: "16px", // Font size
        outline: "none", // Remove focus outline
        appearance: "none", // Remove default dropdown arrow styling
        textAlign: "center", // Center align text
        width: "auto", // Adjust width to content
    },
    container: {
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        textAlign: "center",
    },
    header: {
        marginBottom: "20px",
        fontSize: "24px",
        fontWeight: "bold",
    },
    buttonContainer: {
        marginBottom: "20px",
    },
    button: {
        backgroundColor: "#007BFF",
        color: "#FFFFFF",
        border: "none",
        padding: "10px 20px",
        margin: "0 10px",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "16px",
        transition: "background-color 0.3s",
    },
    buttonHover: {
        backgroundColor: "#0056b3",
    },
    modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 100,
    },
    modal: {
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "8px",
        width: "80%", // Increased width for a larger modal
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
        position: "relative",
    },
    closeButton: {
        position: "absolute",
        top: "10px",
        right: "10px",
        fontSize: "20px",
        border: "none",
        background: "transparent",
        cursor: "pointer",
    },
    form: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)", // Four columns per row
        gap: "15px",
        alignItems: "flex-start",
        width: "100%",
    },
    formHeader: {
        gridColumn: "1 / -1", // Make header span all columns
        marginBottom: "10px",
        fontSize: "20px",
        fontWeight: "bold",
    },
    formHeaders: {
        gridColumn: "1 / -1", // Make header span all columns
        marginBottom: "10px",
        fontSize: "20px",
        fontWeight: "bold",
        display: "flex",
        justifyContent: "space-between",
    },
    label: {
        fontSize: "16px",
        color: "#333",
        display: "flex",
        flexDirection: "column",
    },
    input: {
        width: "100%",
        padding: "10px",
        marginTop: "5px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        fontSize: "16px",
    },
    inputGroup: {
        display: "flex",
        alignItems: "center",
        marginRight: "10px",
        gap: "8px",
    },
    submitButton: {
        gridColumn: "1 / -1", // Make submit button span all columns
        backgroundColor: "#28a745",
        color: "#FFFFFF",
        border: "none",
        padding: "10px 15px",
        borderRadius: "5px",
        cursor: "pointer",
        fontSize: "16px",
        transition: "background-color 0.3s",
    },
};

export default AppointmentDetail;
